<template>
  <v-app>
    <v-main>
      <v-container>
        <v-card>
          <v-card-title dark class="white--text blue">{{ name }}</v-card-title>
          <v-card-text>
            <v-data-table
              class="row-pointer"
              :headers="headers"
              :items="items"
              disable-filtering
              disable-pagination
              hide-default-footer
              @click:row="openLink($event.URL_DOC)"
            >
              <template v-slot:item.TYPE_="{ item }">
                <v-chip color="blue" dark>
                  {{ item.TYPE_ }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-overlay :absolute="true" :value="loading">
          <div style="text-align: center">
            <v-progress-circular indeterminate size="64"> </v-progress-circular>
          </div>
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "App",

  components: {},

  data: () => ({
    loading: false,
    items: [],
    name: "Summary of Benefits and Coverage",
    selectedDoc: "",
    headers: [
      {
        text: "Carrier/Vendor",
        align: "start",
        sortable: true,
        value: "TYPE_",
      },
      {
        text: "Plan Name",
        align: "start",
        sortable: true,
        value: "LONG_DESCRIPTION",
      },
      {
        text: "Language",
        align: "end",
        sortable: true,
        value: "LANG",
      },
    ],
  }),

  methods: {
    openLink(r) {
      window.open(r);
    },

    async GetSBCDocs(selYear) {
      var self = this;
      self.loading = true;
      await axios
        .post(self.methodUrl + "/sbcdocs/WebService.asmx/GetSBCDocs", {
          processing_year: selYear,
        })
        .then((r) => {
          self.items = JSON.parse(r.data.d);
          self.loading = false;
        })
        .catch(() => {
          self.items = [];
        });
    },

    async startup() {
      await this.GetSBCDocs(null);
    },
  },

  created() {
    this.startup();
  },

  computed: {
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },
  },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
